/* eslint-disable i18next/no-literal-string */
export const dateFormatOptions = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' }
];

export const timeZoneOptions = Intl.supportedValuesOf('timeZone').map(timezone => ({
  value: timezone,
  label: timezone
}));
/* eslint-enable i18next/no-literal-string */
